module.exports = __webpack_public_path__ + "static/media/scales3.12306f4a.jpg";